module.exports = __webpack_public_path__ + "img/person.57a48f0e.svg";